import React from 'react'
import '../../Questions.css'
import u1 from '../../Images/u1.png'
import u2 from '../../Images/u2.png'
import u3 from '../../Images/u3.png'
import u4 from '../../Images/u4.png'
import { Link } from 'react-router-dom'
import SideQ from '../../SideQ'
import u5 from '../../Images/u5.png'

export default function Ninth() {
    return (
        <>
            <SideQ />
            <div className="question-container">
                <h1 className='q-h1'>Choose Your Subject - IX th</h1>
                <div className="separation">

                    <Link to="/ninth/physics"><div className="s-items">
                        <img src={u2} className='s-img' alt="" />
                        <h1 className='s-h1'>Physics</h1>
                        <p className='s-p'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi, dolor.</p>
                    </div></Link>


                    <Link to="/ninth/biology"><div className="s-items">
                        <img src={u4} className='s-img' alt="" />
                        <h1 className='s-h1'>Biology</h1>
                        <p className='s-p'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi, dolor.</p>
                    </div></Link>
                    <Link to="/ninth/chemistry"><div className="s-items">
                        <img src={u5} className='s-img' alt="" />
                        <h1 className='s-h1'>Chemistry</h1>
                        <p className='s-p'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi, dolor.</p>
                    </div></Link>

                </div>
            </div>
        </>
    )
}
